import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsync from 'react-use/esm/useAsync';

export const useGitHubUsername = () => {
  const identityApi = useApi(identityApiRef);
  const catalogApi = useApi(catalogApiRef);

  return useAsync(async (): Promise<string | undefined> => {
    const identity = await identityApi.getBackstageIdentity();
    const userRef = identity.userEntityRef;
    if (!userRef) return undefined;

    const match = userRef.match(/^user:(?:[^/]+\/)?(.+)$/);
    if (!match) return undefined;

    const userName = match[1];
    const namespace = userRef.includes('/')
      ? userRef.replace(/^user:/, '').replace(/\/.*$/, '')
      : 'default';

    const { items } = await catalogApi.queryEntities({
      filter: {
        kind: 'user',
        'metadata.namespace': namespace,
        'metadata.name': userName,
      },
      fields: ['metadata.annotations'],
      limit: 1,
    });

    return items[0]?.metadata?.annotations?.['github.com/user-login'];
  }, [identityApi, catalogApi]);
};
